module.exports = __webpack_public_path__ + "static/img/rank_132.c139043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_132.png
// module id = hqYr
// module chunks = 1